import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Modal, Notification } from 'wix-style-react'
// import Divider from 'wix-style-react/src/Viewer/Divider/Divider'
import MessageBoxFunctionalLayout from 'wix-style-react/src/MessageBox/MessageBoxFunctionalLayout'
import * as _ from 'lodash'
import FaCheck from 'react-icons/lib/md/check'
import ArrowLeft from 'react-icons/lib/fa/long-arrow-left'

import Text from 'components/common/Text'
import { DividerHorizontal, DividerVertical } from 'components/shared/Divider'
import InstaImage from './tagProducts/InstaImage'
import ProductsList from 'components/integrations/ProductsList'
import TaggedProductsList from './tagProducts/TaggedProductsList'
import { HELVETICA, TEAL, LIGHT_BLUE, media, BLUE } from 'components/styles'
import AddProduct from 'components/shared/AddProduct'


const Container = styled.div`
  ${media.small`font-size: 12px;`}
  ${media.normal`font-size: 15px;`}
  ${media.huge`font-size: 24px;`}
  width: 100%;
  height: 36em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
const ImageContainer = styled.div`
  width: 32em;
  height: 100%;
  margin-right: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const ProductsContainer = styled.div`
  margin-left: 1em;
  width: 48em;
  height: 100%;
`
const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const TitleButtonsContainer = styled.div`
  display: flex;
`
const ShopifyConnectIconContainer = styled.div`
  margin-right: 5px;
  display: flex;
  align-items: baseline;
`
const ConnectShopifyButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8em;
  height: 1.5em;
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: ${LIGHT_BLUE}
  }
`
const AddProductsButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6em;
  height: 1.5em;
  border: solid 1px #ffffff;
  border-radius: 0.3em;
  cursor: pointer;
  margin-left: 1em;
  background-color: #fff;
  user-select: none;

  &:hover {
    border: solid 1px ${LIGHT_BLUE};
  }
`
const MessageContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`
const TextContainer = styled.div`
  flex: 4;
  margin-left: 1em;
  margin-right: 2em;
  ${HELVETICA}
  font-size: 24px;
  font-weight: 300;
  letter-spacing: 0.7px;
  text-align: center;
  color: ${TEAL}
`

class TagProducts extends Component {

  constructor (props) {
    super(props)
    this.state = {
      activePointIndex: -1,
      addProductModalIsOpen: false,
      addProductNotification: false,
      editProductId: null
    }
  }

  createNewPoint = (left, top) => {
    // console.log('createNewPoint', left, top)
    const { post, updatePost } = this.props
    const postCopy = _.clone(post)
    const products = postCopy.products
    let needReplaceLast = false
    if (products && products.length > 0) {
      const lastProduct = products[products.length - 1]
      if (!_.has(lastProduct, ['info', 'productId'])) {
        // a product is not connected to the point
        needReplaceLast = true
      }
    }
    const point = { left: left, top: top }
    if (needReplaceLast) {
      postCopy.products[products.length - 1] = {point}
    } else {
      if (!products) postCopy.products = []
      postCopy.products.push({point})
    }
    // console.log('updatePost', postCopy)
    updatePost(postCopy)
    this.setState({
      activePointIndex: postCopy.products.length - 1
    })
  }

  componentWillUnmount () {
    const { post, updatePost } = this.props
    const postCopy = _.clone(post)
    const products = postCopy.products
    if (products && products.length > 0) {
      const lastProduct = products[products.length - 1]
      if (!_.has(lastProduct, ['info', 'productId'])) {
        // we need to delete the not completely configured product
        products.splice(products.length - 1)
      }
    }
    // console.log('updatePost', postCopy)
    updatePost(postCopy)
  }

  setActivePoint = (i) => {
    this.setState({
      activePointIndex: i
    })
  }

  onSelectProduct = (product) => {
    // console.log('onSelectProduct', product)
    const { post, updatePost } = this.props
    const { activePointIndex } = this.state
    const postCopy = _.clone(post)
    const products = postCopy.products
    const productInfo = products[activePointIndex]
    if (productInfo) {
      if (productInfo.info && productInfo.info.productId === product.productId) {
        products.splice(activePointIndex, 1)
      } else {
        productInfo.info = {
          productId: product.productId,
          title: product.title
        }
      }
    }
    updatePost(postCopy)
    this.setState({
      activePointIndex: -1,
      addProductNotification: true
    })
    // console.log('postCopy', postCopy)
  }

  hideProductNotification () {
    this.setState({
      addProductNotification: false
    })
  }

  renderTaggedNotification () {
    return (
      <Notification
        onClose={() => this.hideProductNotification()}
        show
        size='small'
        theme='success'
        type='local'
        zIndex={900000}
        timeout={1200}
      >
        <Notification.TextLabel>
          Product tagged
        </Notification.TextLabel>
        <Notification.CloseButton />
      </Notification>
    )
  }

  onEditProduct = (productId) => {
    // console.log('onEditProduct', productId)
    this.openAddProductModal(productId)
  }

  renderMessage () {
    return (
      <MessageContainer>
        <ArrowLeft size={60} color={TEAL} />
        <TextContainer>
          Click anywhere on the instagram image to start tagging products
        </TextContainer>
      </MessageContainer>
    )
  }

  renderProductsList () {
    const { post, productsDict, onDeleteProduct } = this.props
    const { activePointIndex } = this.state
    const products = _.get(post, ['products'], [])
    const productInfo = products[activePointIndex]
    const productId = _.get(productInfo, ['info', 'productId'], '-1')
    if (productInfo && productInfo.point) {
      return (
        <ProductsList
          productsDict={productsDict}
          productId={productId.toString()}
          onSelectProduct={this.onSelectProduct}
          onEditProduct={this.onEditProduct}
          onDeleteProduct={onDeleteProduct}
        />
      )
    } else {
      return this.renderMessage()
    }
  }

  renderContent () {
    const { post, productsDict, postIndex, appId } = this.props
    const { activePointIndex } = this.state
    const products = _.get(post, ['products'], [])
    return (
      <Container>
        <ImageContainer>
          <InstaImage
            products={products}
            image={post.imageStandard}
            createNewPoint={this.createNewPoint}
            activePointIndex={activePointIndex}
            setActivePoint={this.setActivePoint}
          />
          <DividerHorizontal />
          <TaggedProductsList
            appId={appId}
            postIndex={postIndex}
            products={_.takeWhile(products, p => _.has(p, ['info']))}
            productsDict={productsDict}
            onImageClick={this.setActivePoint}
          />
        </ImageContainer>
        <DividerVertical />
        <ProductsContainer>
          {(this.state.addProductNotification) ? this.renderTaggedNotification() : null}
          {this.renderProductsList()}
        </ProductsContainer>
      </Container>
    )
  }

  renderShopifyConnectedCheckIcon () {
    const { shopifyConnected } = this.props
    if (shopifyConnected) {
      return (
        <ShopifyConnectIconContainer>
          <FaCheck color={'#7ed8ab'} size={20} />
        </ShopifyConnectIconContainer>
      )
    }
  }

  closeAddProductModal = () => {
    this.setState({
      addProductModalIsOpen: false,
      editProductId: null
    })
  }

  openAddProductModal = (productId = null) => {
    this.setState({
      addProductModalIsOpen: true,
      editProductId: productId
    })
  }

  renderTitle = () => {
    return (
      <TitleContainer>
        <Text size='medium'>Tag Products</Text>
        <TitleButtonsContainer>
          <ConnectShopifyButton>
            {this.renderShopifyConnectedCheckIcon()}
            <Text size='medium'>Shopify Connected</Text>
          </ConnectShopifyButton>
          <AddProductsButton onClick={this.openAddProductModal}>
            <Text size='medium' color={BLUE}>Add Products</Text>
          </AddProductsButton>

        </TitleButtonsContainer>
      </TitleContainer>
    )
  }

  renderAddProductModal () {
    const { addProductModalIsOpen, editProductId } = this.state
    const { appId, productsDict } = this.props
    const product = _.get(productsDict, editProductId)
    if (addProductModalIsOpen) {
      return (
        <Modal
          zIndex={1000}
          isOpen
          contentLabel='Add product'
          shouldCloseOnOverlayClick
        >
          <AddProduct
            appId={appId}
            onClose={this.closeAddProductModal}
            product={product}
          />
        </Modal>
      )
    }
  }

  render () {
    const { onClose } = this.props
    return (
      <MessageBoxFunctionalLayout
        theme='blue'
        title={this.renderTitle()}
        onCancel={onClose}
        onOk={onClose}
        confirmText='Done Tagging'
        width='80em'
        buttonsHeight='large'
      >
        {this.renderContent()}
        {this.renderAddProductModal()}
      </MessageBoxFunctionalLayout>
    )
  }
}

TagProducts.defaultProps = {
  shopifyConnected: false,
  productsDict: {},
  onDeleteProduct: () => null
}

TagProducts.propTypes = {
  post: PropTypes.object.isRequired,
  postIndex: PropTypes.number.isRequired,
  updatePost: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  shopifyConnected: PropTypes.bool,
  appId: PropTypes.string.isRequired,
  productsDict: PropTypes.object,
  onDeleteProduct: PropTypes.func
}

export default TagProducts



// WEBPACK FOOTER //
// ./src/components/editor/insta/instaTagPosts/TagProducts.js